"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCreditFacilityReceivables = exports.createLoanTapeEvaluators = void 0;
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const toCSV = (tape) => {
    // we need to convert ValleyBankReceivable into a CSV string.
    const buffer = common_1.csvConversion.csvArrayToFinleyBuffer({
        csvArray: tape,
    });
    return buffer;
};
const createLoanTapeEvaluators = (maps, calcAgentMechanics, reportingDate) => __awaiter(void 0, void 0, void 0, function* () {
    const loanProductIdToLoanTapeEvalators = new Map();
    yield Promise.all(Array.from(maps.loanProductToReceivables.keys()).map((loanProductId) => __awaiter(void 0, void 0, void 0, function* () {
        const config = calcAgentMechanics.loanProducts.find((lp) => lp.loanProductId === loanProductId);
        (0, common_1.finleyAssert)(config, `Could not find loan product config for ${loanProductId}`);
        const loanTapeEvaluator = yield (0, calc_agent_1.createLoanTapeEvaluator)({
            config,
            loanTapeType: 'preassignedLoanTape',
            creditFacilityId: 'valley-bank',
            // @vb - we need to pass the correct ids from caller.
            orgSlugMap: {
                valleyBank: {
                    slug: 'valleyBank',
                    id: 'valleyBank',
                },
                valleyBankBorrowers: {
                    slug: 'valleyBankBorrowers',
                    id: 'valleyBankBorrowers',
                },
            },
            loanTapeMetadataExtractor: () => __awaiter(void 0, void 0, void 0, function* () { return ({ reportingDate }); }),
        });
        loanProductIdToLoanTapeEvalators.set(loanProductId, loanTapeEvaluator);
    })));
    return loanProductIdToLoanTapeEvalators;
});
exports.createLoanTapeEvaluators = createLoanTapeEvaluators;
const createCreditFacilityReceivables = ({ maps, calcAgentMechanics, reportingDate, progressCallback, }) => __awaiter(void 0, void 0, void 0, function* () {
    const loanProductIdToLoanTapeEvalators = yield (0, exports.createLoanTapeEvaluators)(maps, calcAgentMechanics, reportingDate);
    const weights = Array.from(maps.loanProductToReceivables.keys()).map((loanProductId) => maps.loanProductToReceivables.get(loanProductId).length);
    const loanProuctCallbacks = (0, calc_agent_1.createPartialProgressCallbacks)({
        progressCallback,
        weights,
    });
    const errors = [];
    const creditFacilityReceivables = [];
    let index = 0;
    for (const [loanProductId, loanTapeEvaluator,] of loanProductIdToLoanTapeEvalators) {
        (0, common_1.finleyAssert)(loanTapeEvaluator, `Could not find loanTapeEvaluator for loanProductId: ${loanProductId}`);
        // convert to cfReceivables
        const { errors: lpErrors, creditFacilityReceivableWithoutFinleyId,
        // eslint-disable-next-line no-await-in-loop
         } = yield loanTapeEvaluator.convertToCreditFacilityReceivables({
            csv: toCSV(maps.loanProductToReceivables.get(loanProductId)),
            progressCallback: loanProuctCallbacks[index],
        });
        // eslint-disable-next-line no-plusplus
        index++;
        lpErrors.forEach((error) => errors.push(error));
        creditFacilityReceivableWithoutFinleyId.forEach((rec) => {
            // eslint-disable-next-line camelcase
            const finley_receivable_id = rec.baseFields.finley_receivable_id;
            (0, common_1.finleyAssert)(
            // eslint-disable-next-line camelcase
            typeof finley_receivable_id === 'string', `finley_receivable_id must exist in ValleyBank CreditFacilityReceivable`);
            creditFacilityReceivables.push(Object.assign(Object.assign({}, rec), { finleyReceivableId: finley_receivable_id, assignmentFields: null }));
        });
    }
    return { errors, creditFacilityReceivables };
});
exports.createCreditFacilityReceivables = createCreditFacilityReceivables;
//# sourceMappingURL=createLoanTapeEvaluators.js.map